
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2070.929-1762.036a1.2 1.2 0 001.045-.557l8.7-13.633a1.91 1.91 0 00.2-.4 1.087 1.087 0 00.063-.352.938.938 0 00-.986-.986 1 1 0 00-.518.122 1.389 1.389 0 00-.41.425l-8.123 12.94-4.209-5.44a1.074 1.074 0 00-.889-.488 1.008 1.008 0 00-.737.283.97.97 0 00-.288.723 1.081 1.081 0 00.073.381 1.332 1.332 0 00.239.391l4.775 6.035a1.353 1.353 0 001.065.556z"}})])])
          )
        }
      }
    